import { useEffect, useState } from "react";
export default function usePhoneLayout() {
  const [phone, setPhone] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const update = () => setPhone(window.innerWidth < 768);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  return phone;
}
